import ApiService from "@/core/services/api.service";
import { cloneDeep, head } from "lodash";
import moment from "moment-timezone";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export const GET_ENGINEERS = "getTrackingEngineers";
export const GET_MAP_ENGINEERS = "getTrackingMapEngineers";
export const GET_MAP_ENGINEER_ROUTES = "getTrackingEngineerRoutes";
export const GET_ENGINEER_STATUS_LIST = "getTrackingEngineerStatusList";
export const GET_VISITS = "getTrackingVisits";
export const GET_VISIT_STATUS_LIST = "getTrackingVisitStatusList";

export const SET_FILTER_DATE = "setTrackingFilterDate";
export const SET_ENGINEERS = "setTrackingEngineers";
export const SET_MAP_ENGINEER_ROUTES = "setTrackingEngineerRoutes";
export const SET_ACTIVE_ENGINEER = "setTrackingActiveEngineer";
export const SET_TRACKING_ENGINEERS = "setTrackingEnabledEngineers";
export const SET_ENGINEER_STATUS_LIST = "setTrackingEngineerStatusList";
export const SET_ENGINEER_STATUS = "setTrackingEngineerStatus";
export const SET_VISITS = "setTrackingVisits";
export const SET_ACTIVE_VISIT = "setTrackingActiveVisit";
export const SET_ROUTES = "setTrackingVisitRoutes";
export const SET_VISIT_STATUS_LIST = "setTrackingVisitStatusList";
export const SET_VISIT_STATUS = "setTrackingVisitStatus";
export const SET_CLEAR_FILTER_DATE = "setTrackingClearFilterDate";
export const SET_ONLINE_STATUS = "setTrackingOnlineStatus";

const engineerStatusList = [
  {
    text: "All Technicians",
    value: "all",
    count: 0,
    color: "cyan",
  },
  {
    text: "Active Technicians",
    value: "active",
    count: 0,
    color: "green",
  },
  {
    text: "In-Active Technicians",
    value: "in-active",
    count: 0,
    color: "red",
  },
];

const visitStatusList = [
  {
    text: "All Visits",
    value: "all",
    count: "0",
    color: "cyan",
  },
  {
    text: "Unassigned Visits",
    value: "unassigned",
    count: "0",
    color: "green",
  },
  {
    text: "Assigned Visits",
    value: "assigned",
    count: "0",
    color: "red",
  },
  {
    text: "Open Visits",
    value: "open",
    count: "0",
    color: "orange",
  },
  {
    text: "In-Progress Visits",
    value: "in-progress",
    count: "0",
    color: "purple",
  },
  {
    text: "Checked-In Visits",
    value: "checked-in",
    count: "0",
    color: "blue",
  },
];

export default {
  state: {
    dbTrackingFilterDate: moment().format("YYYY-MM-DD"),
    dbTrackingEngineers: [],
    dbTrackingEngineerRoutes: [],
    dbTrackingEngineerLoading: false,
    dbTrackingActiveEngineer: {},
    dbTrackingEngineerStatusList: engineerStatusList,
    dbTrackingEngineerStatus: engineerStatusList[1],
    dbTrackingEnabledEngineers: [],
    dbTrackingVisits: [],
    dbTrackingActiveVisit: {},
    dbTrackingVisitLoading: false,
    dbTrackingVisitStatusLoading: false,
    dbTrackingVisitRoutes: [],
    dbTrackingVisitStatusList: visitStatusList,
    dbTrackingVisitStatus: visitStatusList[1],
  },

  getters: {
    trackingActiveEngineer: (state) => state.dbTrackingActiveEngineer,
    trackingFilterDate: (state) => state.dbTrackingFilterDate,
    trackingEngineerRoutes: (state) => state.dbTrackingEngineerRoutes,
    trackingEngineerStatusList: (state) => state.dbTrackingEngineerStatusList,
    trackingEngineerStatus: (state) => state.dbTrackingEngineerStatus,
    trackingEngineerLoading: (state) => state.dbTrackingEngineerLoading,
    trackingEngineers: (state) => state.dbTrackingEngineers,
    trackingEnabledEngineers: (state) => state.dbTrackingEnabledEngineers,
    trackingVisitRoutes: (state) => state.dbTrackingVisitRoutes,
    trackingActiveVisit: (state) => state.dbTrackingActiveVisit,
    trackingVisits: (state) => state.dbTrackingVisits,
    trackingVisitLoading: (state) => state.dbTrackingVisitLoading,
    trackingVisitStatusLoading: (state) => state.dbTrackingVisitStatusLoading,
    trackingVisitStatusList: (state) => state.dbTrackingVisitStatusList,
    trackingVisitStatus: (state) => state.dbTrackingVisitStatus,
  },

  actions: {
    [GET_MAP_ENGINEERS](_, payload) {
      return new Promise((resolve, reject) => {
        ApiService.setHeader();
        ApiService.query("tracking/map/engineers", payload)
          .then(({ data }) => {
            resolve(data.data);
          })
          .catch(reject);
      });
    },
    [GET_MAP_ENGINEER_ROUTES](context, payload) {
      ApiService.setHeader();
      ApiService.query("tracking/map/routes", {
        date: context.state.dbTrackingFilterDate,
        ...payload,
      }).then(({ data }) => {
        const response = data.data;
        context.commit(SET_MAP_ENGINEER_ROUTES, response);
      });
    },
    [GET_ENGINEERS](context, payload) {
      ApiService.setHeader();
      context.state.dbTrackingEngineerLoading = true;
      ApiService.query("tracking/engineers", {
        date: context.state.dbTrackingFilterDate,
        status: context.state.dbTrackingEngineerStatus?.value ?? "all",
        ...payload,
      })
        .then(({ data }) => {
          const response = data.data;
          const trackingResponse = response?.filter(
            (row) => row?.is_tracking_enabled
          );
          context.commit(SET_ENGINEERS, response);
          context.commit(SET_TRACKING_ENGINEERS, trackingResponse);
        })
        .finally(() => {
          context.state.dbTrackingEngineerLoading = false;
        });
    },
    [GET_ENGINEER_STATUS_LIST](context, payload) {
      ApiService.setHeader();
      ApiService.query("tracking/engineers/status", {
        date: context.state.dbTrackingFilterDate,
        ...payload,
      }).then(({ data }) => {
        const response = data.data;
        context.commit(SET_ENGINEER_STATUS_LIST, response);
        context.commit(SET_ENGINEER_STATUS, response[1]);
      });
    },
    [GET_VISITS](context, payload) {
      ApiService.setHeader();
      context.state.dbTrackingVisitLoading = true;
      ApiService.query("tracking/map/visits", {
        date: context.state.dbTrackingFilterDate,
        engineer: context.state.dbTrackingActiveEngineer?.id,
        status: context.state.dbTrackingVisitStatus?.value ?? "unassigned",
        ...payload,
      })
        .then(({ data }) => {
          const response = data.data;
          context.commit(SET_ROUTES, response.routes);
          context.commit(SET_VISITS, response.visits);
        })
        .finally(() => {
          context.state.dbTrackingVisitLoading = false;
        });
    },
    [GET_VISIT_STATUS_LIST](context) {
      ApiService.setHeader();
      context.state.dbTrackingVisitStatusLoading = true;
      ApiService.query("tracking/visits/status", {
        date: context.state.dbTrackingFilterDate,
        engineer: context.state.dbTrackingActiveEngineer?.id,
      })
        .then(({ data }) => {
          const response = data.data;
          context.commit(SET_VISIT_STATUS_LIST, response);
          if (context.state?.dbTrackingActiveEngineer?.id) {
            context.commit(SET_VISIT_STATUS, head(response));
          } else {
            const unassigned = response.find(
              (row) => row.value === "unassigned"
            );
            context.commit(SET_VISIT_STATUS, unassigned);
          }
        })
        .finally(() => {
          context.state.dbTrackingVisitStatusLoading = false;
        });
    },
  },

  mutations: {
    [SET_ONLINE_STATUS](state, payload) {
      state[payload.key][payload.index].is_online = payload.status;
    },
    [SET_CLEAR_FILTER_DATE](state) {
      state.dbTrackingEngineerRoutes = [];
      state.dbTrackingActiveEngineer = {};
      state.dbTrackingEngineers = [];
      state.dbTrackingEnabledEngineers = [];
      state.dbTrackingVisitRoutes = [];
      state.dbTrackingVisits = [];
      state.dbTrackingActiveVisit = {};
    },
    [SET_FILTER_DATE](state, payload) {
      state.dbTrackingFilterDate = payload;
    },
    [SET_MAP_ENGINEER_ROUTES](state, payload) {
      state.dbTrackingEngineerRoutes = cloneDeep(payload);
    },
    [SET_ACTIVE_ENGINEER](state, payload) {
      state.dbTrackingActiveEngineer = cloneDeep(payload);
    },
    [SET_ENGINEERS](state, payload) {
      state.dbTrackingEngineers = cloneDeep(payload);
    },
    [SET_TRACKING_ENGINEERS](state, payload) {
      state.dbTrackingEnabledEngineers = cloneDeep(payload);
    },
    [SET_ENGINEER_STATUS_LIST](state, payload) {
      state.dbTrackingEngineerStatusList = cloneDeep(payload);
    },
    [SET_ENGINEER_STATUS](state, payload) {
      state.dbTrackingEngineerStatus = cloneDeep(payload);
    },
    [SET_ROUTES](state, payload) {
      state.dbTrackingVisitRoutes = cloneDeep(payload);
    },
    [SET_VISITS](state, payload) {
      state.dbTrackingVisits = cloneDeep(payload);
    },
    [SET_ACTIVE_VISIT](state, payload) {
      state.dbTrackingActiveVisit = cloneDeep(payload);
    },
    [SET_VISIT_STATUS_LIST](state, payload) {
      state.dbTrackingVisitStatusList = cloneDeep(payload);
    },
    [SET_VISIT_STATUS](state, payload) {
      state.dbTrackingVisitStatus = cloneDeep(payload);
    },
  },
};
